import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

export const IconRuler: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconRuler"><G ClipPath="url(#clip0_6508_53942)"><Path d="M12.5001 4.086L16.0002 0.585938L23.4144 8.00015L8.00015 23.4144L0.585938 16.0002L4.08588 12.5002L6.75 15.1643L8.16421 13.7501L5.50009 11.086L7.58588 9.00021L11.25 12.6643L12.6642 11.2501L9.00009 7.586L11.0859 5.50021L13.75 8.16434L15.1642 6.75012L12.5001 4.086Z" fill="currentColor"/></G><Defs><ClipPath id="clip0_6508_53942"><Rect width="24" height="24" fill="white"/></ClipPath></Defs></CentralIconBase>;
});

export default IconRuler;
